/* =====================================================================
 * Song-Poster-Editor (PROJ-35) - Player-Look + Spotify-Suche + Scan-Code
 * ABGELEITET vom Magazin-Editor (PROJ-33): identische Foto-Maschinerie,
 * eigenes Player-Chrome + Song-Autocomplete (Django-Spotify-Proxy).
 * =====================================================================
 * Vollflaechiges Kundenfoto + Magazin-Chrome. Kopiervorlagen:
 * - Chrome/Tabs/Produkt-Tab/Cart-Add: kalender-poster.js (JG-Schema)
 * - Foto-Upload (S3 presigned) + Crop-Modal (Cropper.js): letter-poster.js
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderSongposter() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (mpText-Positionen,
 * cqw-Groessen, Barcode, Scrim). Aendert sich der Server, hier mitziehen.
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.SP_BACKEND_API_URL || 'https://tiles.distantlines.de';
  var MAX_FILE_SIZE_MB = 20;
  var CROPPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.css';
  var CROPPER_JS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var SANS = "'Outfit', system-ui, sans-serif";
  var SERIF = "'Playfair Display', Georgia, serif";
  var MP_BARCODE = [3,1,1,2,2,1,3,1,1,1,2,3,1,2,1,1,3,1,2,1,1,2,3,1];
  /* 1:1 Fotoposter (photo.js/photo.css): Filter-Defs + Quality-Schwellen */
  var MP_FILTERS = {
    none: 'none',
    cool: 'saturate(0.85) hue-rotate(-10deg) brightness(1.05)',
    bw: 'grayscale(1) contrast(1.05)',
    soft: 'saturate(0.6) brightness(1.05) contrast(0.95)',
    sepia: 'sepia(0.85) saturate(1.1) brightness(0.95)',
    sommer: 'saturate(1.25) brightness(1.08) hue-rotate(-5deg)',
    vintage: 'sepia(0.4) saturate(1.4) hue-rotate(-15deg) brightness(0.92)'
  };
  var QUALITY_THRESHOLDS = { green: 100, orange: 75 };

  /* ---- Modul-State ---- */
  var root, stage, sectionId;
  var state = {
    title: 'Unser Lied', artist: '', widmung: '',
    duration_ms: 0, track_id: '',
    zeit_text: '',            // linke Zeitanzeige (editierbar, z.B. euer Datum als Timecode)
    bg: 'fullbleed',          // 'fullbleed' | 'light' | 'dark'
    playlist_name: 'Forever and Always',  // fest (Section-Setting, nicht kundeneditierbar)
    filter: 'none',
    natural_width: null, natural_height: null,
    user_image_url: '',       // S3-URL (Payload)
    crop: null,               // {x,y,w,h} 0..1
    paper_size: '30x40', variant_id: '', product_type: '', frame_color: 'brown'
  };
  var photoPreviewUrl = '';   // objectURL fuer die Vorschau
  var cropSourceUrl = '';     // dataURL fuers Crop-Modal
  var isDefaultPhoto = false; // Default-Mockup aktiv (Fotoposter-Muster: Filter
                              // sofort erlebbar; wird NIE gedruckt/hochgeladen)

  /* ===================================================================
   * Render - 1:1-Spiegel von renderSongposter() (Server print-mode.js)
   * =================================================================== */
  function mpText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var align = o.align || 'center';
    var css = 'position:absolute;z-index:6;display:block;top:' + o.y + '%;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + o.color + ';line-height:' + (o.lh || 1.2) + ';';
    if (align === 'left') { css += 'left:' + o.x + '%;transform:translate(0,-50%);text-align:left;'; }
    else if (align === 'right') { css += 'right:' + (100 - o.x) + '%;transform:translate(0,-50%);text-align:right;'; }
    else { css += 'left:' + o.x + '%;transform:translate(-50%,-50%);text-align:center;'; }
    if (o.wrap) { css += 'width:' + o.wrap + '%;white-space:normal;'; }
    else { css += 'white-space:nowrap;'; }
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    if (o.italic) css += 'font-style:italic;';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function mpFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  function applyCropStyles(img, crop) {
    if (!crop) {
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;';
      return;
    }
    img.style.cssText = '';
    img.style.inset = 'auto';
    img.style.position = 'absolute';
    img.style.left = (-(crop.x / crop.w) * 100) + '%';
    img.style.top = (-(crop.y / crop.h) * 100) + '%';
    img.style.width = (100 / crop.w) + '%';
    img.style.height = (100 / crop.h) + '%';
    img.style.maxWidth = 'none';
    img.style.objectFit = 'cover';
  }

  /* 1:1-Spiegel von spPlayerIconsHtml (Server print-mode.js) - 3 Buttons. */
var SP_SHUFFLE_PNG = 'data:image/png;base64,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';
function spPlayerIconsHtml(tc, bg) {
    // 5 Buttons (Vorlage 302953f2): Shuffle / Zurueck / Play / Vor / Repeat.
    // Shuffle+Repeat = saubere Feather-Geometrie (Stroke), Skip/Play gefuellt.
    var st = 'fill="none" stroke="' + tc + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
    // Shuffle = Dominiks Original-PNG als Alpha-Maske (echte Datei), per background-color je Modus eingefaerbt
    var shuffle = '<span style="--m:url(' + SP_SHUFFLE_PNG + ');display:block;width:100%;aspect-ratio:1/1;' +
      'background-color:' + tc + ';-webkit-mask:var(--m) center/contain no-repeat;mask:var(--m) center/contain no-repeat;"></span>';
    var prev = '<svg viewBox="0 0 24 24" fill="' + tc + '" style="width:100%;height:auto;display:block;">' +
      '<rect x="5.4" y="5" width="2.4" height="14" rx="1.1"/>' +
      '<path d="M19 6.3v11.4a1 1 0 0 1-1.55.84l-8.6-5.7a1 1 0 0 1 0-1.68l8.6-5.7A1 1 0 0 1 19 6.3z"/></svg>';
    var play = '<svg viewBox="0 0 24 24" style="width:100%;height:auto;display:block;">' +
      '<circle cx="12" cy="12" r="11" fill="' + tc + '"/>' +
      '<path d="M9.6 7.5v9a.7.7 0 0 0 1.07.6l7-4.5a.7.7 0 0 0 0-1.2l-7-4.5a.7.7 0 0 0-1.07.6z" fill="' + bg + '"/></svg>';
    var next = '<svg viewBox="0 0 24 24" fill="' + tc + '" style="width:100%;height:auto;display:block;">' +
      '<rect x="16.2" y="5" width="2.4" height="14" rx="1.1"/>' +
      '<path d="M5 6.3v11.4a1 1 0 0 0 1.55.84l8.6-5.7a1 1 0 0 0 0-1.68l-8.6-5.7A1 1 0 0 0 5 6.3z"/></svg>';
    var repeat = '<svg viewBox="0 0 24 24" ' + st + ' style="width:100%;height:auto;display:block;">' +
      '<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/>' +
      '<polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>';
    function cell(svg, w) { return '<span style="flex:0 0 auto;width:' + w + ';display:block;">' + svg + '</span>'; }
    return cell(shuffle, '3cqw') + cell(prev, '3.8cqw') + cell(play, '6.4cqw') + cell(next, '3.8cqw') + cell(repeat, '3cqw');
  }

  function spMsToTime(ms) {
    if (!ms || isNaN(ms)) return '';
    var total = Math.round(ms / 1000);
    var m = Math.floor(total / 60), sec = total % 60;
    return (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  /* 1:1-Spiegel von renderSongposter (Server): 3 Modi + Momenterie-Chrome.
     Aenderungen hier IMMER im Server spiegeln (Print-Match). */
  function render() {
    if (!stage) return;
    var mode = state.bg;
    if (mode === 'white') mode = 'light';
    if (mode !== 'fullbleed' && mode !== 'light') mode = 'dark';
    var fullbleed = mode === 'fullbleed', lightMode = mode === 'light';
    var bg = lightMode ? '#ffffff' : '#0f0f10';
    var tc = lightMode ? '#1d1d1d' : '#ffffff';
    var tcSoft = lightMode ? 'rgba(29,29,29,0.6)' : 'rgba(255,255,255,0.64)';

    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.backgroundColor = bg;
    grid.style.borderRadius = '0';

    // ---- Foto: Vollbild oder gerundete Karte ----
    var photoWrap = document.createElement('div');
    if (fullbleed) photoWrap.style.cssText = 'position:absolute;inset:0;overflow:hidden;z-index:1;background:rgba(128,128,128,0.18);';
    else photoWrap.style.cssText = 'position:absolute;left:14%;top:12%;width:72%;aspect-ratio:1/1;overflow:hidden;z-index:1;border-radius:1.4cqw;background:rgba(128,128,128,0.18);';
    if (photoPreviewUrl) {
      var img = document.createElement('img');
      img.alt = '';
      img.src = photoPreviewUrl;
      applyCropStyles(img, state.crop);
      var spf = MP_FILTERS[state.filter] || 'none';
      if (spf !== 'none') img.style.filter = spf;
      photoWrap.appendChild(img);
    }
    grid.appendChild(photoWrap);

    if (fullbleed) {
      var scrim = document.createElement('div');
      scrim.style.cssText = 'position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(180deg,rgba(0,0,0,0.42) 0%,rgba(0,0,0,0) 22%,rgba(0,0,0,0) 55%,rgba(0,0,0,0.72) 100%);';
      grid.appendChild(scrim);
    }

    // ---- Kopf ----
    mpText(grid, { content: 'Wiedergabe aus Playlist', x: 50, y: 6, font: SANS, weight: 500, size: 1.5, color: tcSoft, upper: true, spacing: '0.22em' });
    mpText(grid, { content: state.playlist_name || 'Forever and Always', x: 50, y: 8.6, font: SANS, weight: 700, size: 1.9, color: tc, spacing: '0.02em' });
    var chevron = document.createElement('div');
    chevron.style.cssText = 'position:absolute;left:8%;top:7%;transform:translateY(-50%);width:3cqw;z-index:6;';
    chevron.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="' + tc + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:block;width:100%;height:auto;"><path d="M6 9l6 6 6-6"/></svg>';
    grid.appendChild(chevron);
    var dots = document.createElement('div');
    dots.style.cssText = 'position:absolute;right:8%;top:7%;transform:translateY(-50%);width:4.4cqw;z-index:6;';
    dots.innerHTML = '<svg viewBox="0 0 24 6" fill="' + tc + '" style="display:block;width:100%;height:auto;"><circle cx="4" cy="3" r="1.5"/><circle cx="12" cy="3" r="1.5"/><circle cx="20" cy="3" r="1.5"/></svg>';
    grid.appendChild(dots);

    // ---- Titelblock ----
    var elTitle = mpText(grid, { content: state.title || 'Unser Lied', x: 8, y: 71, align: 'left', font: SANS, weight: 700, size: 3.6, color: tc, lh: 1.05 });
    var elArtist = mpText(grid, { content: state.artist, x: 8, y: 75.5, align: 'left', font: SANS, weight: 500, size: 2.1, color: tcSoft, spacing: '0.02em' });
    var heart = document.createElement('div');
    heart.style.cssText = 'position:absolute;right:8%;top:70.5%;transform:translateY(-50%);width:3.6cqw;z-index:6;';
    heart.innerHTML = '<svg viewBox="0 0 220 200" style="display:block;width:100%;height:auto;"><path d="M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z" fill="' + tc + '"/></svg>';
    grid.appendChild(heart);

    // ---- Balken + Zeit links, ∞ rechts ----
    // Fortschritt (Vorlage 302953f2 'perfect-audio-player'): Zweiton-Linie - heller
    // abgespielter Teil links, gedimmter Rest rechts - + grosser runder Punkt am Stand.
    var pos = 0.42;
    var barWrap = document.createElement('div');
    barWrap.style.cssText = 'position:absolute;left:8%;right:8%;top:82%;transform:translateY(-50%);height:2.6cqw;z-index:6;';
    barWrap.innerHTML =
      '<div style="position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);height:0.45cqw;background:' + tc + ';opacity:0.3;border-radius:1cqw;"></div>' +
      '<div style="position:absolute;left:0;width:' + (pos * 100) + '%;top:50%;transform:translateY(-50%);height:0.45cqw;background:' + tc + ';border-radius:1cqw;"></div>' +
      '<div style="position:absolute;left:' + (pos * 100) + '%;top:50%;transform:translate(-50%,-50%);width:2.4cqw;height:2.4cqw;border-radius:50%;background:' + tc + ';"></div>';
    grid.appendChild(barWrap);
    var durMs = parseInt(state.duration_ms, 10) || 0;
    var leftTime = (state.zeit_text && String(state.zeit_text).trim()) ? state.zeit_text : (durMs ? spMsToTime(durMs * pos) : '');
    mpText(grid, { content: leftTime, x: 8, y: 86.5, align: 'left', font: SANS, weight: 500, size: 1.45, color: tcSoft, spacing: '0.04em' });
    mpText(grid, { content: '\u221e', x: 92, y: 86.2, align: 'right', font: SANS, weight: 600, size: 2.9, color: tcSoft });

    // ---- Controls ----
    var icons = document.createElement('div');
    icons.style.cssText = 'position:absolute;left:50%;top:89.5%;transform:translate(-50%,-50%);display:flex;align-items:center;gap:3.6cqw;z-index:6;';
    icons.innerHTML = spPlayerIconsHtml(tc, bg);
    grid.appendChild(icons);

    if (state.track_id) {
      var code = document.createElement('img');
      code.alt = '';
      code.style.cssText = 'position:absolute;left:50%;top:95.5%;transform:translate(-50%,-50%);width:26%;z-index:6;';
      var codeUri = 'spotify%3Atrack%3A' + encodeURIComponent(state.track_id);
      if (fullbleed) {
        // Vollbild: kein Kasten - schwarzer Hintergrund wird per Canvas transparent
        // gekeyt (Helligkeit = Alpha), weisse Balken bleiben auf dem dunklen Scrim.
        var codeSrc = new Image();
        codeSrc.crossOrigin = 'anonymous';
        codeSrc.onload = function () {
          try {
            var cv = document.createElement('canvas');
            cv.width = codeSrc.naturalWidth; cv.height = codeSrc.naturalHeight;
            var cx = cv.getContext('2d');
            cx.drawImage(codeSrc, 0, 0);
            var im = cx.getImageData(0, 0, cv.width, cv.height), d = im.data;
            for (var i = 0; i < d.length; i += 4) {
              var lum = Math.max(d[i], d[i + 1], d[i + 2]);
              d[i] = 255; d[i + 1] = 255; d[i + 2] = 255; d[i + 3] = lum;
            }
            cx.putImageData(im, 0, 0);
            code.src = cv.toDataURL('image/png');
          } catch (e) { code.src = codeSrc.src; } // Fallback: Original mit Kasten
        };
        codeSrc.src = 'https://scannables.scdn.co/uri/plain/png/000000/white/640/' + codeUri;
      } else {
        var codeBg = lightMode ? 'ffffff' : '0f0f10';
        var codeBars = lightMode ? 'black' : 'white';
        code.src = 'https://scannables.scdn.co/uri/plain/png/' + codeBg + '/' + codeBars + '/640/' + codeUri;
      }
      grid.appendChild(code);
    }
    mpText(grid, { content: state.widmung, x: 8, y: 78.6, align: 'left', font: SANS, weight: 500, size: 1.35, color: tcSoft, spacing: '0.02em', wrap: 60 });

    // ---- Editor-only: Foto-CTA ----
    if (!photoPreviewUrl) {
      var cta = document.createElement('div');
      cta.className = 'sp-photo-cta';
      var ctaBox = fullbleed
        ? 'position:absolute;inset:0;'
        : 'position:absolute;left:14%;top:12%;width:72%;aspect-ratio:1/1;';
      cta.style.cssText = ctaBox + 'z-index:8;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;cursor:pointer;color:' + tc + ';font-family:Outfit,system-ui,sans-serif;font-size:13px;letter-spacing:0.05em;';
      cta.innerHTML = '<svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg><span>Foto hochladen</span>';
      cta.addEventListener('click', pickPhoto);
      grid.appendChild(cta);
    }

    stage.innerHTML = '';
    stage.appendChild(grid);

    var fitReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    fitReady.then(function () {
      mpFit(elTitle, 70);
      mpFit(elArtist, 70);
    });
  }

  /* ===================================================================
   * Foto: Upload (S3 presigned, letter-poster-Muster) + Crop-Modal
   * =================================================================== */
  function pickPhoto() {
    var fileInput = document.getElementById('sp-file-input');
    if (fileInput) fileInput.click();
  }

  function handleFile(file) {
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert('Das Foto ist groesser als ' + MAX_FILE_SIZE_MB + ' MB - bitte ein kleineres waehlen.');
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      cropSourceUrl = String(reader.result);
      photoPreviewUrl = cropSourceUrl;
      isDefaultPhoto = false;
      state.crop = null;
      var probe = new Image();
      probe.onload = function () {
        state.natural_width = probe.naturalWidth;
        state.natural_height = probe.naturalHeight;
        updatePhotoUiState();
      };
      probe.src = cropSourceUrl;
      render();
      updatePhotoUiState();
      openCropModal();
    };
    reader.readAsDataURL(file);

    // Upload parallel (Payload braucht die S3-URL)
    uploadToS3(file).then(function (publicUrl) {
      state.user_image_url = publicUrl;
    }).catch(function (err) {
      console.error('[song-poster] S3 upload failed', err);
      state.user_image_url = '';
    });
  }

  async function uploadToS3(file) {
    // 1:1 letter-poster.js: presigned POST mit FormData-Fields (KEIN PUT -
    // der scheitert am Objectstorage-CORS-Preflight)
    var presignedResp = await fetch(BACKEND_API_URL + '/api/v1/upload/presigned-url/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name || 'song-photo.jpg', content_type: file.type || 'image/jpeg' })
    });
    if (!presignedResp.ok) throw new Error('Presigned URL failed: HTTP ' + presignedResp.status);
    var presigned = await presignedResp.json();
    var uploadUrl = presigned.uploadUrl || presigned.upload_url;
    var publicUrl = presigned.publicUrl || presigned.public_url;
    var fields = presigned.fields || {};
    if (!uploadUrl || !publicUrl) throw new Error('Invalid presigned response');
    var formData = new FormData();
    Object.keys(fields).forEach(function (k) { formData.append(k, fields[k]); });
    formData.append('file', file);
    var uploadResp = await fetch(uploadUrl, { method: 'POST', body: formData });
    if (!uploadResp.ok && uploadResp.status !== 204) throw new Error('S3 upload failed: HTTP ' + uploadResp.status);
    return publicUrl;
  }

  /* ---- Crop-Modal (Cropper.js on-demand, Kissen/Letterposter-Muster) ---- */
  var _cropper = null, _cropBackdrop = null, _cropInitialRatio = null;
  function ensureCropper() {
    return new Promise(function (resolve, reject) {
      if (window.Cropper) { resolve(); return; }
      if (!document.querySelector('link[data-cropper]')) {
        var lk = document.createElement('link');
        lk.rel = 'stylesheet'; lk.href = CROPPER_CSS_URL; lk.setAttribute('data-cropper', '1');
        document.head.appendChild(lk);
      }
      var sc = document.createElement('script');
      sc.src = CROPPER_JS_URL;
      sc.onload = function () { resolve(); };
      sc.onerror = function () { reject(new Error('Cropper konnte nicht geladen werden')); };
      document.head.appendChild(sc);
    });
  }
  function buildCropBackdrop() {
    var bd = document.createElement('div');
    bd.className = 'collage-cropper-modal-backdrop';
    bd.innerHTML =
      '<div class="collage-cropper-modal">' +
        '<div class="collage-cropper-modal-header"><h3>Foto zuschneiden</h3></div>' +
        '<div class="collage-cropper-wrapper"><img alt=""></div>' +
        '<p class="collage-cropper-help">Verschiebe den Rahmen oder zoome, bis dein Motiv sitzt - der Ausschnitt fuellt das ganze Cover.</p>' +
        '<div class="collage-cropper-zoom-bar">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-out" aria-label="Verkleinern">&minus;</button>' +
          '<input type="range" class="collage-zoom-slider" min="100" max="200" value="100" aria-label="Zoom">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-in" aria-label="Vergrößern">+</button>' +
        '</div>' +
        '<div class="collage-cropper-modal-footer">' +
          '<button type="button" class="collage-crop-cancel">Abbrechen</button>' +
          '<button type="button" class="primary collage-crop-apply">Zuschneiden &amp; übernehmen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bd);
    bd.addEventListener('click', function (e) { if (e.target === bd) closeCropModal(); });
    bd.querySelector('.collage-crop-cancel').addEventListener('click', closeCropModal);
    bd.querySelector('.collage-crop-apply').addEventListener('click', applyCropFromModal);
    var zs = bd.querySelector('.collage-zoom-slider');
    if (zs) zs.addEventListener('input', function () {
      if (!_cropper || !_cropInitialRatio) return;
      _cropper.zoomTo(_cropInitialRatio * (parseInt(this.value, 10) / 100));
    });
    bd.querySelector('.collage-zoom-in').addEventListener('click', function () { if (_cropper) _cropper.zoom(0.1); });
    bd.querySelector('.collage-zoom-out').addEventListener('click', function () { if (_cropper) _cropper.zoom(-0.1); });
    return bd;
  }
  function posterAspect() {
    // Vollbild = Poster-Hochformat (3:4), Karten-Modi = quadratisch (1:1)
    if (state.bg === 'fullbleed') {
      var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(state.paper_size || '');
      var w = m ? parseInt(m[1], 10) : 30, h = m ? parseInt(m[2], 10) : 40;
      return Math.min(w, h) / Math.max(w, h);
    }
    return 1;
  }
  function openCropModal() {
    if (!cropSourceUrl) { pickPhoto(); return; }
    ensureCropper().then(function () {
      if (!_cropBackdrop) _cropBackdrop = buildCropBackdrop();
      _cropBackdrop.classList.add('visible');
      document.body.style.overflow = 'hidden';
      initCropperImage();
    }).catch(function (e) { console.error(e); alert('Crop-Editor konnte nicht geladen werden.'); });
  }
  function initCropperImage() {
    var img = _cropBackdrop.querySelector('.collage-cropper-wrapper img');
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    var _built = false;
    img.onload = function () {
      if (_built) return; _built = true;
      requestAnimationFrame(function () {
        _cropper = new Cropper(img, {
          aspectRatio: posterAspect(),
          viewMode: 1, autoCropArea: 1,
          movable: true, zoomable: true, rotatable: false, scalable: false,
          cropBoxResizable: true, responsive: false, background: false, modal: true,
          dragMode: 'none', toggleDragModeOnDblclick: false, // kein Neu-Aufziehen ausserhalb der Box (Clarity 10.08.)
          minCropBoxWidth: 60, minCropBoxHeight: 60,
          wheelZoomRatio: 0.08,
          ready: function () {
            var cd = _cropper.getCanvasData();
            _cropInitialRatio = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
            var zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
            if (zs) zs.value = 100;
            if (state.crop) {
              var d = _cropper.getImageData();
              _cropper.setData({ x: state.crop.x * d.naturalWidth, y: state.crop.y * d.naturalHeight, width: state.crop.w * d.naturalWidth, height: state.crop.h * d.naturalHeight });
            }
          }
        });
      });
    };
    img.src = cropSourceUrl;
    if (img.complete && img.naturalWidth) img.onload();
  }
  function applyCropFromModal() {
    if (!_cropper) { closeCropModal(); return; }
    var data = _cropper.getData();
    var id = _cropper.getImageData();
    var NW = id.naturalWidth || 1, NH = id.naturalHeight || 1;
    state.crop = {
      x: Math.max(0, Math.min(1, data.x / NW)),
      y: Math.max(0, Math.min(1, data.y / NH)),
      w: Math.max(0.01, Math.min(1, data.width / NW)),
      h: Math.max(0.01, Math.min(1, data.height / NH))
    };
    closeCropModal();
    render();
    updatePhotoUiState();
  }
  function closeCropModal() {
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    if (_cropBackdrop) _cropBackdrop.classList.remove('visible');
    document.body.style.overflow = '';
  }

  /* ===================================================================
   * Foto-UI-Zustaende + Qualitaetsanzeige + Filter (1:1 Fotoposter-Muster)
   * =================================================================== */
  function updatePhotoUiState() {
    var hasCustomerPhoto = !!photoPreviewUrl && !isDefaultPhoto;
    var changeRow = document.getElementById('sp-change-row');
    if (changeRow) changeRow.classList.toggle('visible', hasCustomerPhoto);
    var uploadBtn = document.getElementById('sp-upload-zone');
    if (uploadBtn) uploadBtn.style.display = hasCustomerPhoto ? 'none' : '';
    var hint = root.querySelector('.photo-upload-hint');
    if (hint) hint.style.display = hasCustomerPhoto ? 'none' : '';
    // Filter immer zeigen, sobald IRGENDEIN Bild da ist (auch das Default -
    // Fotoposter-Muster: Kunde kann sofort durchzappen)
    var stageHint = document.getElementById('sp-stage-hint-' + sectionId);
    if (stageHint) stageHint.style.display = isDefaultPhoto ? '' : 'none';
    var picker = document.getElementById('sp-filter-picker');
    if (picker) {
      picker.style.display = photoPreviewUrl ? '' : 'none';
      if (photoPreviewUrl) picker.querySelectorAll('.filter-thumb-img').forEach(function (im) {
        if (im.src !== photoPreviewUrl) im.src = photoPreviewUrl;
      });
    }
    updateQualityIndicator();
  }

  function computeQualityForPaperSize(paperWidthCm, paperHeightCm) {
    if (!state.natural_width || !state.natural_height) return null;
    var cropW = (state.crop && state.crop.w) || 1;
    var cropH = (state.crop && state.crop.h) || 1;
    var dpiW = (state.natural_width * cropW) / (paperWidthCm / 2.54);
    var dpiH = (state.natural_height * cropH) / (paperHeightCm / 2.54);
    var dpi = Math.min(dpiW, dpiH);
    var level = dpi >= QUALITY_THRESHOLDS.green ? 'green' : (dpi >= QUALITY_THRESHOLDS.orange ? 'orange' : 'red');
    return { level: level, dpi: Math.round(dpi) };
  }

  function updateQualityIndicator() {
    var btn = document.getElementById('sp-quality-btn');
    if (!btn) return;
    if (!state.natural_width || !photoPreviewUrl || isDefaultPhoto) { btn.style.display = 'none'; return; }
    var dim = parsePosterDim(state.paper_size);
    var shortE = Math.min(dim.w, dim.h), longE = Math.max(dim.w, dim.h);
    var result = computeQualityForPaperSize(shortE, longE);
    if (!result) { btn.style.display = 'none'; return; }
    btn.style.display = 'flex';
    btn.setAttribute('data-level', result.level);
    var statusEl = btn.querySelector('.quality-status');
    var labels = { green: 'Ausgezeichnet', orange: 'Akzeptabel', red: 'Niedrig' };
    if (statusEl) statusEl.textContent = labels[result.level] || '';
    var iconEl = btn.querySelector('.quality-icon');
    if (iconEl) {
      var svg;
      if (result.level === 'green') {
        svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7.5l3 3 5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      } else if (result.level === 'orange') {
        svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      } else {
        svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 3v5M7 10.5v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      }
      iconEl.innerHTML = svg;
    }
  }

  function initFilterPicker() {
    root.querySelectorAll('#sp-filter-picker a[data-filter]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var choice = a.getAttribute('data-filter');
        if (!(choice in MP_FILTERS)) return;
        root.querySelectorAll('#sp-filter-picker a[data-filter]').forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.filter = choice;
        render();
      });
    });
  }

  /* ===================================================================
   * Song-Suche (Autocomplete via Django-Spotify-Proxy)
   * =================================================================== */
  var _searchTimer = null;
  function initSongSearch() {
    var input = document.getElementById('sp-song-search');
    var dropdown = document.getElementById('sp-song-results');
    if (!input || !dropdown) return;
    function hide() { dropdown.style.display = 'none'; dropdown.innerHTML = ''; }
    input.addEventListener('input', function () {
      clearTimeout(_searchTimer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      _searchTimer = setTimeout(function () {
        fetch(BACKEND_API_URL + '/api/v1/spotify/search?q=' + encodeURIComponent(q))
          .then(function (r) { return r.ok ? r.json() : { tracks: [] }; })
          .then(function (data) {
            var tracks = data.tracks || [];
            if (!tracks.length) { hide(); return; }
            dropdown.innerHTML = '';
            tracks.forEach(function (t) {
              var li = document.createElement('li');
              li.innerHTML = (t.cover ? '<img src="' + t.cover + '" alt="" loading="lazy">' : '<span class="sp-cover-ph"></span>') +
                '<span>' + t.title + ' - ' + t.artist + '</span>';
              li.addEventListener('click', function () {
                state.title = t.title;
                state.artist = t.artist;
                state.duration_ms = t.duration_ms || 0;
                state.track_id = t.id || '';
                var ti = document.getElementById('sp-title'); if (ti) ti.value = t.title;
                var ar = document.getElementById('sp-artist'); if (ar) ar.value = t.artist;
                input.value = t.title + ' - ' + t.artist;
                hide();
                updateSpotifyEmbed();
                render();
              });
              dropdown.appendChild(li);
            });
            dropdown.style.display = 'block';
          })
          .catch(function () { hide(); });
      }, 300);
    });
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target) && e.target !== input) hide();
    });
  }

  /* Spotify-Embed-Player (nur Editor-Vorschau, KEIN Druck): kostenloser
     open.spotify.com/embed/track/<id>-iframe - braucht nur die Track-ID,
     keinen API-Key. Zeigt den schwarzen abspielbaren Player wie beim Wettbewerber. */
  function updateSpotifyEmbed() {
    var box = document.getElementById('sp-embed');
    if (!box) return;
    if (state.track_id) {
      box.innerHTML = '<iframe style="border-radius:10px;border:0;width:100%;height:80px;" ' +
        'src="https://open.spotify.com/embed/track/' + encodeURIComponent(state.track_id) + '?utm_source=distantlines" ' +
        'loading="lazy" allow="encrypted-media; clipboard-write; fullscreen; picture-in-picture"></iframe>';
      box.style.display = '';
    } else {
      box.innerHTML = '';
      box.style.display = 'none';
    }
  }

  /* ===================================================================
   * Eingaben: Textfelder, Textfarbe, Scrim, Preset-Chips
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }
  function initToggleRow(selector, key) {
    var btns = root.querySelectorAll(selector);
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        btns.forEach(function (x) { x.classList.remove('current'); });
        b.classList.add('current');
        state[key] = b.getAttribute('data-value');
        render();
      });
    });
    var active = root.querySelector(selector + '.current');
    if (active) state[key] = active.getAttribute('data-value');
  }
  function initPresetChips() {
    root.querySelectorAll('.sp-preset-chips [data-preset][data-target]').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var val = c.getAttribute('data-preset') || '';
        var target = c.getAttribute('data-target');
        var input = document.getElementById(target);
        if (input) input.value = val;
        var keyMap = { 'sp-headline': 'headline', 'sp-edition': 'edition', 'sp-kicker': 'kicker' };
        var key = keyMap[target];
        if (key) state[key] = val;
        render();
      });
    });
  }
  function initUploadButton() {
    // Fotoposter-Muster: Upload-Label mit verstecktem file-input; nach Upload
    // erscheint die Change-Row (Neu zuschneiden / Anderes Foto)
    var fileInput = document.getElementById('sp-file-input');
    if (fileInput) fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) handleFile(f);
      fileInput.value = '';
    });
    var recrop = document.getElementById('sp-recrop-btn');
    if (recrop) recrop.addEventListener('click', function (e) { e.preventDefault(); openCropModal(); });
    var change = document.getElementById('sp-change-btn');
    if (change) change.addEventListener('click', function (e) { e.preventDefault(); if (fileInput) fileInput.click(); });
    stage.addEventListener('click', function () {
      if (isDefaultPhoto || !photoPreviewUrl) { pickPhoto(); return; }
      openCropModal();
    });
  }

  /* Info-Gluehbirne + Tabs (Standard-Muster) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) close.addEventListener('click', function (e) {
        e.preventDefault();
        content.style.display = 'none';
        toggle.classList.remove('is-active');
      });
    });
  }
  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['foto__wrapper', 'text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (<=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 JG/Kalender-Schema
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.sp-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('sp-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
    updateQualityIndicator();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }
  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Kalender/JG-Muster: Sync-Render, dann /cart/add.js
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('sp-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    if (!state.user_image_url || isDefaultPhoto) {
      // Fotoposter-Muster (V9.96.29j): schoenes Modal statt Browser-Alert
      var noticeModal = document.getElementById('sp-cart-no-photo-modal');
      if (noticeModal) noticeModal.classList.add('visible');
      else pickPhoto();
      return;
    }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);

        var payload = {
          product: 'songposter',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          user_image_url: state.user_image_url,
          crop: state.crop,
          title: state.title,
          artist: state.artist,
          duration_ms: state.duration_ms,
          track_id: state.track_id,
          widmung: state.widmung,
          bg: state.bg,
          filter: state.filter || 'none'
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/songposter/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/songposter/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Fallback-URL bleibt */ }

        var props = {
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          // Cart-Vorschau (PROJ-72): persistentes Komposit vom Render-Worker
          '_preview_image_url': BACKEND_API_URL + '/media/blanket_renders/' + jobId + '_cartpreview.jpg',
          '_groesse': state.paper_size,
          '_produkt': 'songposter',
          '_Song': (state.title || '') + (state.artist ? ' - ' + state.artist : '')
        };
        if (state.widmung && state.widmung.trim()) props['_Widmung'] = state.widmung;
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        // Sofort-Vorschau (PROJ-72): Schnappschuss der sichtbaren Stage in
        // sessionStorage, damit der Warenkorb das Motiv SOFORT zeigt. Helper
        // ist fail-soft (2,5s-Notbremse) - blockiert den Kauf nie.
        var vorschauFertig = (window.kaSofortVorschau ? window.kaSofortVorschau(stage, jobId) : Promise.resolve());
        await vorschauFertig;

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[song-poster] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* Cart-ohne-Foto-Modal (Fotoposter-Muster): Close + Backdrop schliessen,
     CTA oeffnet den File-Picker */
  function initNoticeModal() {
    var noticeModal = document.getElementById('sp-cart-no-photo-modal');
    var noticeClose = document.getElementById('sp-cart-no-photo-close');
    var noticeCta = document.getElementById('sp-cart-no-photo-cta');
    if (!noticeModal) return;
    function close() { noticeModal.classList.remove('visible'); }
    if (noticeClose) noticeClose.addEventListener('click', close);
    noticeModal.addEventListener('click', function (e) {
      if (e.target === noticeModal) close();
    });
    if (noticeCta) noticeCta.addEventListener('click', function (e) {
      e.preventDefault();
      close();
      pickPhoto();
    });
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.sp-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('sp-stage-' + sectionId);

    state.playlist_name = root.dataset.playlistName || state.playlist_name;
    if (root.dataset.defaultPhoto) {
      photoPreviewUrl = root.dataset.defaultPhoto;
      isDefaultPhoto = true;
    }
    bindField('sp-playlist', 'playlist_name');
    bindField('sp-zeit', 'zeit_text');
    bindField('sp-title', 'title');
    bindField('sp-artist', 'artist');
    bindField('sp-widmung', 'widmung');
    initToggleRow('.sp-color-btn[data-value]', 'bg');
    initSongSearch();
    updateSpotifyEmbed();
    initPresetChips();
    initUploadButton();
    initFilterPicker();
    initNoticeModal();
    updatePhotoUiState();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('sp-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
